<template>
  <div class="grid-container full programemsCarousel">

    <div class="grid-x header show-for-medium">
      <div class="auto cell text-center">
          <h2
            tabindex="30"
            :class="{selected: frameToDisplay === 'uni' }"
            @keypress="frameToDisplay = 'uni'"
            @click="frameToDisplay = 'uni'">
            Schools</h2>
      </div>
<!--      <div class="auto  cell text-center">
          <h2
            tabindex="31"
            :class="{selected: frameToDisplay === 'foundations' }"
            @keypress="frameToDisplay = 'foundations'"
            @click="frameToDisplay = 'foundations'">
            First Year Uni</h2>
      </div>-->
    </div>

    <div class="grid-x show-for-small-only headerSmall page-contents-8">
      <div class="small-12 cell">
        <select class="logoSector" v-model="frameToDisplay">
          <option value="uni">Schools</option>
          <option value="foundations">First Year Uni</option>
        </select>
      </div>
    </div>


    <div v-if="frameToDisplay === 'uni'">
      <div class="grid-x page-contents-8">
        <div class="small-12 cell text-center">
          <p class="show-for-medium">We partner with schools and universities to offer one-to-one support with university applications and personal statements,
            CV and interview workshops, debating and commercial awareness sessions. We also develop and recruit for
            bespoke work experience placements.</p>
          <p class="show-for-small-only">We partner with schools and universities to offer one-to-one support, workshops and group tasks.</p>
        </div>
      </div>

      <preUni/>

    </div>

    <div v-if="frameToDisplay === 'foundations'">
      <div class="grid-x page-contents-8">
        <div class="small-12 cell text-center">
          <p class="show-for-medium">A series of introductory career programmes for Black undergraduates. Run in
            partnership with our clients, Rare Foundations gives candidates the sector knowledge, understanding and
            relationships to distinguish themselves from their peers.</p>
          <p class="show-for-small-only">A series of introductory career programmes for ethnic minority undergraduates.</p>
        </div>
      </div>

      <foundations/>

    </div>

  </div>
</template>

<script>

import RareStandardButton from 'rare-patternlab/buttons/RareStandardButton';
import developmentCarouselPreUni from './developmentCarouselPreUniversity';
import developmentCarouselFoundations from './developmentCarouselFoundations';

export default {
  name: 'RareProgrammesCarousel',
  components: {
    preUni: developmentCarouselPreUni,
    foundations: developmentCarouselFoundations,
    'rare-apply-button': RareStandardButton,
  },
  props: {
    variation: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      frameToDisplay: 'uni',
    };
  },
  methods: {
    applyQualifiedLawyers() {
      window.open('https://rarecitylawyers.app.contextualrecruitment.com/apply/08b8f21d-3c66-445b-92b6-801dc5809c97', '_blank');
    },
    openFAQModal() {
      this.$router.push({ path: '/qualified-lawyers-faq' });
    },
  },
};
</script>

<style lang="scss" scoped>

  @import "~@/css/global.scss";

  .center-button-cont {
    align-items: center;
    display: flex;
    justify-content: center;
    margin-top: 70px;
  }

  .programemsCarousel {
    background-color: #343C43;
  }

  .header {
    border-bottom: 1px solid #4a5b68;
    padding: 0 15% 0 15%;
    margin-bottom: 32px;
  }

  .logoSector {
    background-color: transparent;
    background-image: url("data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAATCAQAAABbncd8AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAAHdElNRQfiBwISLzndysPJAAAAoElEQVQ4y5XUSw7DIAwAUS84I/ncj0V6RZCmi7QqprYhRooUoXnKxhGERCEjD0+mkBAhcQH1IZGpwEUSCve0B8SdA5T+pbEt5RvtU1Sy9lYIlSPjJ82IIf8CmtjdfB/zH7BCGHkPzAgz14AmDnVz2PkIeISb/wMWEeQWoImTM8ptQBNh7gE9EeY+oIlgV1d2Llz1eHEydfanSBLNq3s68war4OLSs3ptUQAAAABJRU5ErkJggg==");
    background-size: 24px;
    background-position: right;
    border: none;
    border-bottom: 4px solid $brown-highlight;
    color: #ffffff;
    display: block;
    font-size: 28px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    height: auto;
    padding: 0;
    letter-spacing: 4px;
    text-align: center;
  }

  .logoSector:focus {
    box-shadow: none;
  }

  .modalLink {
    border-bottom: 1px dotted #ffffff;
    cursor: pointer;
    color: #ffffff;
    font-size: 12px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.5;
    letter-spacing: 2px;
    text-align: left;
    margin-left: 60px;
    height: 20px;
  }

  .modalLink:hover {
    border-color: transparent;
  }

  h2
  {
    color: #848a8e;
    cursor: pointer;
    display: inline;
    font-size: 32px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 80px;
    padding-bottom: 7px;
    text-align: center;
    margin:0;
  }

  h2.selected {
    border-bottom: 4px solid $brown-highlight;
    color: #ffffff;
    font-size: 52px;
  }

  p {
    color: #ffffff;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
  }

  @media only screen and (max-width: 640px)  {
    .programemsCarousel {
      background-color: #343C43;
      min-height: 409px;
      padding-top: 48px;
    }

    p {
      font-size: 14px;
    }

    .center-button-cont {
      margin: 30px 0 20px 0;
    }

    .center-button-cont:first-of-type {
      margin-bottom: 0;
    }

    .modalLink {
      margin: 0;
    }

    .emailButton {
      margin: 0;
    }

  }

  @media only screen and (min-width: 641px)  {

    .programemsCarousel {
      background-color: #343C43;
      min-height: 675px;
      padding-top: 96px;
    }

    p {
      font-size: 21px;
    }
  }


</style>



// WEBPACK FOOTER //
// src/components/carousels/developmentCarousel.vue